<template>
  <div>
    <div class="head">
      <a class="logo"><img src="../assets/logo.png" alt=""></a>
      <!--      <div class="tit" >-->
      <div class="tit" style="text-align: center">
        <!--        <img src="../assets/tit2.png" alt="">-->
        <span
          style="text-shadow: 0 0 10px #aed0ee;color: white;font-size: 2vw;text-align: center;">全球商业联盟通用积分促销实时交易结算数据中心</span>
      </div>
      <div style="width: 15%;display: flex;justify-content:space-between ">
        <a class="zongbu" @click="toZongBu">总部</a>
        <a class="area" @click="openCityList">{{ selectCity.cityName }}</a>
      </div>
    </div>
    <div class="main">
      <div class="numlist">
        <div class="item" v-for="(item,index) in numList" :key="index">
          <img :src="item.icon" alt="">
          <div class="txt">
            <p><span><b>{{ item.num }}</b>{{ item.unit }}</span>
              <i class="up" v-if='item.isup'>⬆</i>
            </p>
            <h6>{{ item.name }}</h6>
          </div>
        </div>
      </div>
      <div class=" scrollbar" @click="clickParts">
        <!--        <vue-seamless-scroll :data="cityList" :class-option="defaultOption" class="scrolls">-->
        <div class="scrolls" id="scrolls">
          <!--          <div class="parts" v-for="(item,index) in cityList" :key="index" @click="clickParts">-->
          <div class="parts" v-for="(item,index) in cityList" :key="index">

            <div class="ptit">

              <p @click="toDataCenter(item.cityName,item.cityCode)" style="cursor: pointer;">{{ item.cityName }}</p>

              <span>合伙人总数{{
                  item.totalPartnerCount
                }}人</span></div>
            <div class="lists">
              <div class=" child">
                <div class="litem">地区</div>
                <div class="litem">商家数量</div>
                <div class="litem">会员数量</div>
                <div class="litem">现金交易额</div>
                <div class="litem">积分交易额</div>
                <div class="litem">今日新增会员</div>
                <div class="litem"></div>
              </div>
              <div class="child lista" v-for="(p,pindex) in item.detailDTOList" :key="pindex">
                <div class="litem">{{ p.countyName }}</div>
                <div class="litem">{{ p.storeCount }}</div>
                <div class="litem">{{ p.userCount }}</div>
                <div class="litem">{{ p.totalMoney }}元</div>
                <div class="litem">{{ p.totalScore }}积分</div>
                <div class="litem">{{ p.toDayCount }}</div>
                <div class="litem"><a class="join" @click="toDataCenter(p.countyName,p.cityCode)">进入数据中心</a></div>
              </div>
            </div>
          </div>
        </div>
        <!--        </vue-seamless-scroll>-->
      </div>
    </div>
    <div class="pops" v-if="showpop">

      <div class="bg"></div>

      <img src="../assets/a27.png" class="line" alt="">
      <div class="mid">
        <i class="top"></i>
        <i class="right"></i>
        <i class="down"></i>
        <i class="left"></i>
        <a class="close" @click="showpop=false">关闭</a>
        <div class="citys scrollbar">
          <div class="citem" v-for="(item,index) in allCity" :key="index">
            <h3><span>{{ item.fullname }}</span></h3>
            <div class="list">
              <a class="lka" v-for="(p,pindex) in item.childList" :key="pindex"
                 @click="clickCityName(p)">{{ p.fullname }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import {
  getAreaAll,
  getCountyDetail,
  getPartnerCount,
  getRecCityIdList,
  getTodayTradeVolume,
  getUserNewCount
} from "../api/index";


export default {
  name: 'index',
  components: {
    vueSeamlessScroll
  },
  props: {},
  computed: {
    defaultOption() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  data() {
    return {
      numList: [
        {icon: require('@/assets/a14.png'), num: 0, unit: '人', isup: true, name: '今日新增会员'},
        {icon: require('@/assets/a14.png'), num: 0, unit: '人', isup: true, name: '本月新增会员'},
        {icon: require('@/assets/a14.png'), num: 0, unit: '人', isup: false, name: '会员总数'},
        {icon: require('@/assets/a15.png'), num: 0, unit: '人', isup: false, name: '合伙人总数'},
        {icon: require('@/assets/a16.png'), num: 0, unit: '元', isup: false, name: '今日现金交易额'},
        {icon: require('@/assets/a17.png'), num: 0, unit: '积分', isup: false, name: '今日积分交易额'}
      ],
      cityList: [],
      allCity: [{
        fullname: "直辖市",
        areaId: "1000",
        childList: []
      }],
      cityMap: {},
      selectCity: {
        cityId: "",
        cityName: "切换地区",
      },
      showpop: false,
      interval: {obj: {}, prev: 0, start: true},
      partnerQuery: {},
    }

  },
  mounted() {

    this.$nextTick(() => {

      const elem = document.getElementById('scrolls');

      let prev = 0;

      this.interval.obj = window.setInterval(function () {

        prev = elem.scrollTop;
        elem.scrollTop += 1; //AUTOINCREMENT SCROLL
        // console.log(prev)
        if (prev === elem.scrollTop && prev !== 0) {
          elem.scrollTop = 0;
        }
      }, 10);

    });

  },
  created() {
    this.cityMap = new Map();
    this.loadAreaList();
    this.loadUserCount();
    this.loadTradeData();
    this.loadRecCityTotalList();

  },
  methods: {
    loadAreaList() {
      const that = this;
      getAreaAll({}).then(res => {
        that.allCity = res.list;

        let citystemp = [];

        that.allCity.forEach(item => {
          citystemp = citystemp.concat(item.childList);
        })

        citystemp.forEach(item => {
          that.cityMap.set(item.areaId, item.childList)
        })

        // that.allCity = that.allCity.concat(res.list);
        // console.log(that.allCity)
        console.log(that.cityMap)
        window.sessionStorage.setItem('cityMap', JSON.stringify(that.cityMap))
      }).catch(e => {
        console.log(e.message)
      });
    },
    loadUserCount() {

      let countyIdList = [this.selectCity.cityId];
      if (this.selectCity.cityId !== '') {
        let countyList = this.cityMap.get(this.selectCity.cityId);
        countyIdList = countyList.map(item => item.areaId);
      }

      let op = {
        nowType: 'now_day',
        areaIdList: countyIdList,
      }
      const that = this;
      //查询今日会员数量
      getUserNewCount(op).then(res => {
        that.numList[0].num = res.data;
      }).catch(e => {
        console.log(e.message)
      });

      op.nowType = 'now_month';
      //查询本月会员数量
      getUserNewCount(op).then(res => {
        that.numList[1].num = res.data;
      }).catch(e => {
        console.log(e.message)
      });


      //查询当前地区全部会员数量
      getUserNewCount({areaIdList: countyIdList}).then(res => {
        that.numList[2].num = res.data;
      }).catch(e => {
        console.log(e.message)
      });

      //查询合伙人数量
      getPartnerCount({areaIdList: countyIdList}).then(res => {
        that.numList[3].num = res.data;
        that.numList[3].num += 2000;
      }).catch(e => {
        console.log(e.message)
      });

    },
    loadTradeData() {

      let countyIdList = [this.selectCity.cityId];
      if (this.selectCity.cityId !== '') {
        let countyList = this.cityMap.get(this.selectCity.cityId);
        countyIdList = countyList.map(item => item.areaId);
      }


      const that = this;

      let op = {
        tradeType: 'money',
        areaIdList: countyIdList,
      }

      //查询今日现金交易量
      getTodayTradeVolume(op).then(res => {
        that.numList[4].num = res.data;
      }).catch(e => {
        console.log(e.message)
      });

      op.tradeType = 'score'
      //查询今日积分交易量
      getTodayTradeVolume(op).then(res => {
        that.numList[5].num = res.data;
      }).catch(e => {
        console.log(e.message)
      });
    },

    loadRecCityTotalList() {

      const that = this;

      getRecCityIdList({limitCount: 15}).then(res => {
        getCountyDetail({
          cityIds: res.list
        }).then(res2 => {
          that.cityList = res2.list;
          if(res2.list ===[]){
            location.reload();
          }
        }).catch(e => {
          console.log(e.message)
        });
      }).catch(e => {
        console.log(e.message)
      });

    },

    loadCityTotalList() {
      const that = this;
      getCountyDetail({
        cityIds: [this.selectCity.cityId]
      }).then(res => {
        console.log(res)
        that.cityList = res.list;
      }).catch(e => {
        console.log(e.message)
      });
    },
    openCityList() {
      this.showpop = true;
    },
    toZongBu() {
      this.$router.push({path: '/home', query: {cityName: '全球商业联盟通用积分促销', cityCode: '100000'}});
    },
    clickCityName(item) {
      const that = this;
      this.selectCity.cityName = item.fullname;
      this.selectCity.cityId = item.areaId;
      this.showpop = false;

      this.loadUserCount();
      this.loadTradeData();
      this.loadCityTotalList();

    },
    toDataCenter(cityName, cityCode) {
      // console.log(item)
      this.$router.push({path: '/home', query: {cityName: cityName, cityCode: cityCode}});
      // console.log(cityId)
    },
    clickParts() {
      this.interval.start = !this.interval.start;

      // console.log(this.interval.start)

      if (!this.interval.start) {
        clearInterval(this.interval.obj);
        this.$nextTick(() => {
          const elem = document.getElementById('scrolls');
          this.interval.prev = elem.scrollTop;
          // console.log(this.interval.prev)
        });
      } else {

        this.$nextTick(() => {

          const elem = document.getElementById('scrolls');

          let prev = 0;

          this.interval.obj = window.setInterval(function () {

            prev = elem.scrollTop;
            elem.scrollTop += 1;
            // console.log(prev)
            if (prev === elem.scrollTop && prev !== 0) {
              elem.scrollTop = 0;
            }
          }, 10);


        })
      }

    }

  }
}
</script>

<style>
.scrolls {
  height: 67vh;
  overflow-y: scroll;
  transition: top 0.01s linear;
  margin-top: 5.5vh;
  /*-webkit-overflow-scrolling: touch;    !* ios5+ *!*/

}

.scrolls::-webkit-scrollbar {
  display: none;
}

.parts {
  margin-bottom: 5.8vh;
}

.parts .ptit {
  height: 6.5vh;
  background: url(../assets/a24.png) no-repeat center center / auto 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1vw;
  color: #00d4ff;
}

.parts .ptit p {
  font-size: 1.3vw;
  font-weight: bold;
  color: #00d4ff;
}

.parts .ptit span {
  padding-left: 3vw;
  margin-left: 3vw;
  border-left: 1px solid rgba(0, 212, 255, 0.3);
}

.parts .lists {
  border: 1px solid #0e3990;
  border-right: none;
  border-radius: 8px;
}

.parts .lists .child {
  overflow: hidden;
  font-weight: bold;
  background-color: #01225f;
}

.parts .lists .child .litem {
  width: 14.28%;
  float: left;
  height: 7.1vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9vw;
  color: #00d4ff;
  border-right: 1px solid #0e3990;
}

.parts .lists .child .join {
  display: block;
  cursor: pointer;
  background: url(../assets/a25.png) no-repeat center center / 100% 100%;
  height: 4.2vh;
  padding: 0 0.6vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85vw;
  color: #00bfe9;
}

.parts .lists .lista:nth-child(2n) {
  background-color: #14316d;
}

.parts .lists .lista:nth-child(2n+1) {
  background-color: #0c2965;
}

.pops {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}

.pops .bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.65);
}

.pops .mid {
  position: absolute;
  left: 15%;
  right: 15%;
  top: 15vh;
  bottom: 15vh;
  z-index: 3;
  background-color: #07215d;
  border: solid 1px #00d4ff;
  padding: 5vh 1.5vw 4vh;
}

.pops .mid .close {
  position: absolute;
  right: 1.5vw;
  top: 1vh;
  font-size: 1.1vw;
  color: #00bfe9;
  cursor: pointer;
  z-index: 3;
  line-height: 4vh;
}

.pops .mid .citys {
  height: calc(60vh);
  overflow-y: auto;
  padding: 0 15px;
}

.pops .mid .citys h3 {
  overflow: hidden;
  margin-bottom: 24px;
}

.pops .mid .citys h3 span {
  font-size: 0.9vw;
  color: #00bfe9;
  height: 5.7vh;
  background: url(../assets/a26.png) no-repeat center center / 100% 100%;
  padding: 0 2vw 0 1.2vw;
  float: left;
  display: flex;
  align-items: center;
}

.pops .mid .citys .list {
  overflow: hidden;
}

.pops .mid .citys .list .lka {
  float: left;
  width: calc(16.66% - 20px);
  margin-right: 24px;
  margin-bottom: 24px;
  background-color: #203669;
  border-radius: 8px;
  border: solid 1px #00d4ff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8vw;
  color: #00bfe9;
  height: 6vh;
}

.pops .mid .citys .list .lka:nth-child(6n) {
  margin-right: 0;
}

.pops .mid > i {
  width: 30px;
  height: 30px;
  border: 2px solid #00d4ff;
  position: absolute;
}

.pops .mid > i.top {
  left: -12px;
  top: -12px;
  border-right: none;
  border-bottom: none;
}

.pops .mid > i.right {
  right: -12px;
  top: -12px;
  border-left: none;
  border-bottom: none;
}

.pops .mid > i.down {
  left: -12px;
  bottom: -12px;
  border-right: none;
  border-top: none;
}

.pops .mid > i.left {
  right: -12px;
  bottom: -12px;
  border-left: none;
  border-top: none;
}

.pops .line {
  position: fixed;
  right: 4vw;
  top: 6.7vh;
  width: 15vw;
  z-index: 2;
}

.zongbu {
  text-align: center;
  height: 4.9vh;
  color: #00bfe9;
  line-height: 4.9vh;
  padding-right: 20px;
  padding-left: 20px;
  margin-right: 15px;
  background: url(../assets/a01.png) no-repeat center center / 100% 100%;

}
</style>
<!--
{
fullname: "直辖市",
areaId: "1000",
childList: [{fullname: '北京市', areaId: '1002'},
{fullname: '上海市', areaId: '1020'},
{fullname: '天津市', areaId: '1038'},
{fullname: '重庆市', areaId: '2700'}]
}-->



// WEBPACK FOOTER //
// src/pages/index.vue